import React from "react";
import Typography from "@material-ui/core/Typography";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Divider from "@material-ui/core/Divider";
import AlertDialog from "./alert.component";

import Grid from "@material-ui/core/Grid";
import { Api } from "../utils/api";
import PlanDetailsForm from "./forms/plan-details.form";
import { EstablishmentPlanBadge } from "../user_requests/components/establishment_plan_badge.component";
import moment from "moment";

export class PlanDetailsCard extends React.Component {
  state = {
    showAlert: false,
    alertTitle: "",
    alertMessage: "",
  };

  constructor() {
    super();
    this.form = null;
    this.api = new Api();
    this.setForm = this.setForm.bind(this);
    this.submit = this.submit.bind(this);
    this.showAlert = this.showAlert.bind(this);
    this.closeAlert = this.closeAlert.bind(this);
  }

  /**
   *
   */

  showAlert(title, message) {
    this.setState({ showAlert: true });
    this.setState({ alertTitle: title });
    this.setState({ alertMessage: message });
  }

  closeAlert() {
    this.setState({ showAlert: false });
  }

  /**
   *
   */

  setForm(form) {
    this.form = form;
  }

  submit(values, action) {
    const entityPlan = this.props.entity_plan;
    const id = entityPlan.id;
    const entity_plan = {
      ended_at: moment(values.ended_at).utc(true),
    };

    if (id !== undefined) {
      //update
      this.api
        .patch(`/entity_plans/${id}`, { entity_plan })
        .then((res) => {
          console.log("patch " + id + ": ", res);
          this.showAlert("Sucesso", "Alterações guardadas com sucesso!");
        })
        .catch((err) => {
          console.log("patch " + id + ": ", err);
          this.showAlert("Erro", "Ocorreu um erro a gravar as alterações!");
        });
    }
  }

  /**
   *
   */

  render() {
    const reference = this.props.reference;
    const entity_plan = this.props.entity_plan;
    return (
      <>
        <ExpansionPanel square>
          <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
            <Grid container alignItems="center">
              <Grid item md={4}>
                <Typography variant="body2">
                  {entity_plan && entity_plan.entity_name}
                </Typography>
              </Grid>
              <Grid item md={2}>
                <EstablishmentPlanBadge
                  plan={entity_plan && entity_plan.plan_name}
                />
              </Grid>
              <Grid item md={3}>
                <Typography variant="body2">
                  <span>Ref. MB:</span>
                  {reference && reference.ep_reference
                    ? reference.ep_reference
                    : ""}
                </Typography>
              </Grid>
              <Grid item md={2}>
                <Typography variant="body2">
                  <span>Estado plano: </span>{" "}
                  {entity_plan && entity_plan.plan_id !== 1
                    ? "Activo"
                    : "Inactivo"}
                </Typography>
                <Typography variant="body2">
                  <span>Estado ref: </span>{" "}
                  {reference && reference.active ? "Activa" : "Inactiva"}
                </Typography>
              </Grid>
              <Grid container>
                <Typography gutterBottom variant="caption" variant="body2">
                  {reference && reference.entity_vat
                    ? reference.entity_vat
                    : ""}
                </Typography>
              </Grid>
            </Grid>
          </ExpansionPanelSummary>

          {entity_plan && entity_plan.plan_id !== 1 && (
            <ExpansionPanelDetails>
              <PlanDetailsForm
                onSubmit={this.submit}
                getForm={this.setForm}
                {...entity_plan}
              />
            </ExpansionPanelDetails>
          )}

          <Divider />
        </ExpansionPanel>

        <AlertDialog
          open={this.state.showAlert}
          handleClose={this.closeAlert}
          title={this.state.alertTitle}
          message={this.state.alertMessage}
        ></AlertDialog>
      </>
    );
  }
}
